import { BaseModel } from "./BaseModel";
import { CalculationHelper, CalculationModel } from "./CalculationHelper";
import { CalcualtionResultKeys, TabNames } from '../modules/Constants';

export class FinancialDashboardModel extends BaseModel {
    overrideFormatSheet() {
        let result = {}
        result.rows = [];

        let emptyCell = {
            backgroundColor: '#f9f9f9',
            verticalAlign: 'middle',
        }

        this.Display.BaseInfo.forEach((row, rowIndex) => {
            let rowData = {}
            rowData.cells = row.map((column, columnIndex) => {
                let cell = {};

                cell.style = this.defaultCell();
                cell.wrap = true;
                cell.value = column;

                if (cell.value === "") {
                    cell.style = emptyCell;
                }

                if (columnIndex > 0 && rowIndex > 4) {
                    if (rowIndex == 7 || rowIndex == 9) {
                        cell.format = '0.00%';
                    } else {
                        cell.format = '#,##0.00';
                    }
                }

                if ((columnIndex == 0 && cell.value != null) || (rowIndex == 4 && cell.value == "")) {
                    cell.style = this.defaultHeader();
                }

                if (!isFinite(cell.value)) {
                    cell.format = null;
                }

                return cell;
            });
            result.rows.push(rowData);
        });

        this.Display.Pricing.forEach((row, rowIndex) => {
            let rowData = {}
            let startingColumn = 0;
            let startingRow = result.rows.length;

            rowData.cells = row.map((column, columnIndex) => {
                let cell = {};

                cell.style = this.defaultCell();
                cell.wrap = true;
                cell.value = column;
                cell.format = '#,##0.00';

                if (cell.value === "") {
                    cell.style = emptyCell;
                }

                if ((columnIndex == 0 && cell.value != null) || (rowIndex == 0 && cell.value == "")) {
                    cell.style = this.defaultHeader();
                    cell.format = null;
                }

                if (!isFinite(cell.value)) {
                    cell.format = null;
                }

                return cell;
            });

            if (result.rows[rowIndex + startingRow]) {
                var exisitingRow = result.rows[rowIndex + startingRow];
                exisitingRow.cells.push({});
                exisitingRow.cells.push.apply(exisitingRow.cells, rowData.cells);

            } else {
                var cells = Array(startingColumn).fill({})
                cells.push.apply(cells, rowData.cells);
                rowData.cells = cells;
                result.rows.push(rowData);
            }
        });

        this.Display.Material.forEach((row, rowIndex) => {
            let rowData = {}
            let startingColumn = 0;
            let startingRow = result.rows.length;

            rowData.cells = row.map((column, columnIndex) => {
                let cell = {};

                cell.style = this.defaultCell();
                cell.wrap = true;
                cell.value = column;
                cell.format = '0.00%';

                if (cell.value === "") {
                    cell.style = emptyCell;
                }

                if ((columnIndex == 0 && cell.value != null) || (rowIndex == 0 && cell.value == "")) {
                    cell.style = this.defaultHeader();
                    cell.format = null;
                }

                if (column != null && column[0] === '=') {
                    cell.formula = column;
                    if (column.includes("!")) {
                        cell.format = '#,##0.00';
                    } else {
                        cell.format = '0.00%';
                    }
                }

                if (!isFinite(cell.value)) {
                    cell.format = null;
                }

                return cell;
            });

            if (result.rows[rowIndex + startingRow]) {
                var exisitingRow = result.rows[rowIndex + startingRow];
                exisitingRow.cells.push({});
                exisitingRow.cells.push.apply(exisitingRow.cells, rowData.cells);

            } else {
                var cells = Array(startingColumn).fill({})
                cells.push.apply(cells, rowData.cells);
                rowData.cells = cells;
                result.rows.push(rowData);
            }
        })

        this.Display.Engineering.forEach((row, rowIndex) => {
            let rowData = {}
            let startingColumn = 3;
            let startingRow = 0;

            rowData.cells = row.map((column, columnIndex) => {
                let cell = {};

                cell.style = this.defaultCell();
                cell.wrap = true;
                cell.value = column;
                cell.format = '#,##0.00';

                if (cell.value === "") {
                    cell.style = emptyCell;
                }

                if (columnIndex == 2) {
                    cell.format = '0.00%';
                }

                if ((columnIndex == 0 && cell.value != null) || (rowIndex == 0 && cell.value != "")) {
                    cell.style = this.defaultHeader();
                    cell.format = null;
                }

                if (!isFinite(cell.value)) {
                    cell.format = null;
                }

                return cell;
            });

            if (result.rows[rowIndex + startingRow]) {
                var exisitingRow = result.rows[rowIndex + startingRow];
                exisitingRow.cells.push({});
                exisitingRow.cells.push.apply(exisitingRow.cells, rowData.cells);

            } else {
                var cells = Array(startingColumn).fill({})
                cells.push.apply(cells, rowData.cells);
                rowData.cells = cells;
                result.rows.push(rowData);
            }
        });

        this.Display.Investment.forEach((row, rowIndex) => {
            let rowData = {}
            let startingColumn = 3;
            let startingRow = this.Display.Engineering.length;

            rowData.cells = row.map((column, columnIndex) => {
                let cell = {};

                cell.style = this.defaultCell();
                cell.wrap = true;
                cell.value = column;
                cell.format = '#,##0.00';

                if (cell.value === "") {
                    cell.style = emptyCell;
                }

                if (columnIndex == 2) {
                    cell.format = '0.00%';
                }

                if ((columnIndex == 0 && cell.value != null) || (rowIndex == 0 && cell.value != "")) {
                    cell.style = this.defaultHeader();
                    cell.format = null;
                }

                if (!isFinite(cell.value)) {
                    cell.format = null;
                }

                return cell;
            });

            if (result.rows[rowIndex + startingRow]) {
                var exisitingRow = result.rows[rowIndex + startingRow];
                exisitingRow.cells.push({});
                exisitingRow.cells.push.apply(exisitingRow.cells, rowData.cells);

            } else {
                var cells = Array(startingColumn).fill({})
                cells.push.apply(cells, rowData.cells);
                rowData.cells = cells;
                result.rows.push(rowData);
            }
        })

        this.Display.Rebill.forEach((row, rowIndex) => {
            let rowData = {}
            let startingColumn = 3;
            let startingRow = this.Display.Engineering.length + this.Display.Investment.length;

            rowData.cells = row.map((column, columnIndex) => {
                let cell = {};

                cell.style = this.defaultCell();
                cell.wrap = true;
                cell.value = column;
                cell.format = '#,##0.00';

                if (cell.value === "") {
                    cell.style = emptyCell;
                }


                if ((columnIndex == 0 && cell.value != null)) {
                    cell.style = this.defaultHeader();
                    cell.format = null;
                }

                if (!isFinite(cell.value)) {
                    cell.format = null;
                }

                return cell;
            });

            if (result.rows[rowIndex + startingRow]) {
                var exisitingRow = result.rows[rowIndex + startingRow];
                exisitingRow.cells.push({});
                exisitingRow.cells.push.apply(exisitingRow.cells, rowData.cells);

            } else {
                var cells = Array(startingColumn).fill({})
                cells.push.apply(cells, rowData.cells);
                rowData.cells = cells;
                result.rows.push(rowData);
            }
        })

        this.Display.IncomeStatement.forEach((row, rowIndex) => {
            let rowData = {}
            let startingColumn = 8;
            let startingRow = 0;

            rowData.cells = row.map((column, columnIndex) => {
                let cell = {};

                cell.style = this.defaultCell();
                cell.wrap = true;
                cell.value = column;
                cell.format = '#,##0.00';

                if (cell.value === "") {
                    cell.style = emptyCell;
                }

                if (rowIndex == 13 || columnIndex % 2 === 0 && columnIndex >= 2) {
                    cell.format = '0.00%';
                }

                if ((columnIndex == 0 && cell.value != null) || (rowIndex == 0 && cell.value != null)) {
                    cell.style = this.defaultHeader();
                    cell.format = null;
                }

                if (!isFinite(cell.value)) {
                    cell.format = null;
                }

                return cell;
            });

            if (result.rows[rowIndex + startingRow]) {
                var exisitingRow = result.rows[rowIndex + startingRow];
                exisitingRow.cells.push({});
                exisitingRow.cells.push.apply(exisitingRow.cells, rowData.cells);

            } else {
                var cells = Array(startingColumn).fill({})
                cells.push.apply(cells, rowData.cells);
                rowData.cells = cells;
                result.rows.push(rowData);
            }
        })

        result.columns = Array(Math.max(...result.rows.map(i => i.cells.length))).fill({ width: 150 }); 

        return result;
    }

    constructor() {
        super();
        this.TabName = TabNames.FINANCIAL_DASHBOARD;
        this.TabIndex = 1;
        this.DataProcessor = new FinancialDashboardProcessor();
        this.formatSheet = this.overrideFormatSheet;
    }

}

export class FinancialDashboardProcessor {

    process(data) {
        let Calculations = [];
        let Calcs = data.calculations_parsed[1];
        let ExchangeRates = [];
        let Volumes = [];
        let Records = [];
        let Currency = data.currency;

        let study = data.study;
        let snapshots = data.snapshots;
        let version = data.version;

        study.exchangeRates.forEach(rate => {
            rate.Item2.Values.forEach(item => {
                ExchangeRates.push({
                    currency: rate.Item1,
                    year: new Date(item.Date).getUTCFullYear(),
                    value: item.Value
                });
            });
        });

        Calcs.forEach(calc => {
            Calculations.push(new CalculationModel(calc.calculationText, calc.calculation, calc.val, calc.amount, ExchangeRates, Currency))
        })

        let SaleableParts = [];
        snapshots.forEach(snapshot => {
            snapshot.SaleableParts.forEach(part => {
                part.OptionName = snapshot.GroupName
                SaleableParts.push(part);
                let key = new CalculationHelper().getPartKey(part);
                Volumes[key] = { first: 0, total: 0, years: [] };


                var firstYearIndex = part.CostStudyVolume.Value.Fields[0].Values.findIndex(x => x.Value > 0)
                if (!firstYearIndex || firstYearIndex == -1) {
                    firstYearIndex = 0
                }
                let firstYear = part.CostStudyVolume.Value.Fields[0].Values[firstYearIndex];
                Volumes[key].first = firstYear.Value;
                Volumes[key].firstYear = new Date(firstYear.Date).getUTCFullYear();


                part.CostStudyVolume.Value.Fields.forEach(volume => {
                    volume.Values.forEach(value => {
                        Volumes[key].total += value.Value;
                        var year = new Date(value.Date).getUTCFullYear();
                        Volumes[key].years[year] = (Volumes[key].years[year] ?? 0) + value.Value;
                    });
                });
            });

        });

        var model = new FinancialDashboardRowModel(version, Calculations, Volumes, SaleableParts);
        Records.push(model);

        let result = {
            headers: [],
            display: this.getDisplay(Records, Currency),
            numerics: []
        };

        return result;
    }


    getDisplay(Records, Currency) {

        let display = {};

        display.BaseInfo = this.getBaseTable(Records, Currency);
        display.Pricing = this.getPricingTable(Records);
        display.Material = this.getMaterialTable(Records);
        display.Engineering = this.getEngineeringTable(Records);
        display.Investment = this.getInvestmentTable(Records);
        display.Rebill = this.getRebillTable(Records);
        display.IncomeStatement = this.getIncomeStatementTable(Records);



        return display;
    }

    getBaseTable(Records, Currency) {
        var result = [
            ["Cost Study", Records[0].CostStudy],
            ["Version", Records[0].Version],
            ["Currency", Currency],
            [null, null],
            ["Key Metrics", ""],
            ["LTR $M", Records[0].TotalRevenueM],
            ["Volume K", Records[0].VolumeK],
            ["OI %", Records[0].OperatingIncomePercent],
            ["NPV $k", Records[0].NPVk],
            ["IRR %", Records[0].IRR],
            [null, null]
        ]
        return result;
    }

    getPricingTable(Records) {
        var result = [
            ["Pricing", ""],
            ["Year 1 Price", Records[0].Year1Price],
            ["Year 1 Price (HVP)", Records[0].Year1PriceHVP],
            ["APR", Records[0].APRs],
            ["NCP", Records[0].NCPs],
            ["Customer FwL", Records[0].CustomerFwL],
            ["Historical", ""],
            [null, null],
        ]
        return result;
    }

    getMaterialTable(Records) {
        var result = [
            ["Material", ""],
            ["Performance", Records[0].MaterialAPRs],
            ["Year 1", Records[0].MatlYear1],
            ["Year 1 (HVP)", Records[0].MatlYear1HVP],
            ["Pgrm Avg", Records[0].MatlProgramAvg],
            ["Pgrm Avg (HVP)", Records[0].MatlProgramAvgHVP],
            ["PL Target", ""],
            ["Net Squeeze", `='${TabNames.MATERIAL_SQUEEZE}'!B1`],
            ["% to LTR", "=B27/B6/1000"],
            [null, null],
        ]

        return result;
    }

    getEngineeringTable(Records) {
        var result = [
            ["Engineering $K", "Bus. Case", "% LTR", "PL Target"],
            ["Application Engineering", Records[0].ApplicationEngineeringK, Records[0].ApplicationEngineeringPercentToLTR, ""],
            ["CI & Pursuit Engineering", Records[0].CIAndPursuitEngineeringK, Records[0].CIAndPursuitEngineeringPercentToLTR, ""],
            ["Studied Engineering", Records[0].StudiedEngineeringK, Records[0].StudiedEngineeringPercentToLTR, ""],
            ["R&D Tax", Records[0].RAndDTaxK, Records[0].RAndDTaxPercentToLTR, ""],
            ["Gross Eng", Records[0].GrossEngK, Records[0].GrossEngPercentToLTR, ""],
            ["Engineering Rebill Revenue", Records[0].EngineeringRebillRevenueK, Records[0].EngineeringRebillRevenuePercentToLTR, ""],
            [null, null, null, null],
        ]
        return result;
    }

    getInvestmentTable(Records) {
        var result = [
            ["Investment $K", "Bus. Case", "% LTR", "PL Target"],
            ["Facilities", Records[0].FacilitiesK, Records[0].FacilitiesPercentToLTR, ""],
            ["Tooling", Records[0].ToolingK, Records[0].ToolingPercentToLTR, ""],
            ["Expense", Records[0].ExpenseK, Records[0].ExpensePercentToLTR, ""],
            ["Gross Investment", Records[0].GrossInvestmentK, Records[0].GrossInvestmentPercentToLTR, ""],
            ["Tooling Rebill", Records[0].ToolingRebillK, Records[0].ToolingRebillPercentToLTR, ""],
            ["Net Investment", Records[0].NetInvestmentK, Records[0].NetInvestmentPercentToLTR, ""],
            ["Net Capex", Records[0].NetCapexK, Records[0].NetCapexPercentToLTR, ""],
            [null, null, null, null],
        ]
        return result;
    }

    getRebillTable(Records) {
        var result = [
            ["ME Rebillable Tooling", Records[0].MERebillableToolingK, null, null],
            ["All Vendor Tools", Records[0].AllVendorToolsK, null, null],
            ["Rebill to customer", Records[0].ToolingRebillK, null, null],
            ["Net Tool Rebill", Records[0].NetToolRebillK, null, null],
            [null, null, null, null],
        ]
        return result;
    }

    getIncomeStatementTable(Records) {
        var result = [
            ["Income Statment Per Unit - $Avg Total Prgm Life", "Yr 1", "% LTR", "Bus. Case", " % LTR"],
            ["Revenue", Records[0].RevenueYr1PerUnit, "", Records[0].RevenuePerUnit, ""],
            ["Material", Records[0].MaterialYr1PerUnit, Records[0].MaterialYr1PercentToLTR, Records[0].MaterialPerUnit, Records[0].MaterialPercentToLTR],
            ["Freight & Duty", Records[0].FreightAndDutyYr1PerUnit, Records[0].FreightAndDutyYr1PercentToLTR, Records[0].FreightAndDutyPerUnit, Records[0].FreightAndDutyPercentToLTR],
            ["Manufacturing (Labor + Burden)", Records[0].ManufacturingYr1_PerUnit, Records[0].ManufacturingYr1_PercentToLTR, Records[0].Manufacturing_PerUnit, Records[0].Manufacturing_PercentToLTR],
            ["St up + Ops Exp", Records[0].StUp_OpsExpYr1_PerUnit, Records[0].StUp_OpsExpYr1_PercentToLTR, Records[0].StUp_OpsExp_PerUnit, Records[0].StUp_OpsExp_PercentToLTR],
            ["Other Incremental + TL Rebill", Records[0].OtherIncremental_TlRebillYr1_PerUnit, Records[0].OtherIncremental_TlRebillYr1_PercentToLTR, Records[0].OtherIncremental_TlRebill_PerUnit, Records[0].OtherIncremental_TlRebill_PercentToLTR],
            ["Factory Profit", Records[0].FactoryProfitYr1PerUnit, Records[0].FactoryProfitYr1PercentToLTR, Records[0].FactoryProfitPerUnit, Records[0].FactoryProfitPercentToLTR],
            ["Mfg D&A", Records[0].MfgDAndAYr1PerUnit, Records[0].MfgDAndAYr1PercentToLTR, Records[0].MfgDAndAPerUnit, Records[0].MfgDAndAPercentToLTR],
            ["OCOGS", Records[0].OCOGSYr1PerUnit, Records[0].OCOGSYr1PercentToLTR, Records[0].OCOGSPerUnit, Records[0].OCOGSPercentToLTR],
            ["SG&A", Records[0].SGAndAYr1PerUnit, Records[0].SGAndAYr1PercentToLTR, Records[0].SGAndAPerUnit, Records[0].SGAndAPercentToLTR],
            ["Engineering", Records[0].EngineeringYr1PerUnit, Records[0].EngineeringYr1PercentToLTR, Records[0].EngineeringPerUnit, Records[0].EngineeringPercentToLTR],
            ["Operating Income", Records[0].OperatingIncomeYr1PerUnit, Records[0].OperatingIncomeYr1PercentToLTR, Records[0].OperatingIncomePerUnit, Records[0].OperatingIncomePercentToLTR],
            ["NPV $K", "", "", Records[0].NPVk, ""],
            ["IRR", "", "", Records[0].IRR, ""],
            ["Reach", "", "", "", ""],
            ["Fx Rate", "", "", "", ""],
            ["Prorated (in) / out", "", "", "", ""],
            [null, null, null],
        ]

        Records[0].Parts.forEach((part, index) => {
            result[0].push(part  + " - Total Per Unit", part + " - % LTR");
            result[1].push(Records[0].RevenuePerPart[index], "");
            result[2].push(Records[0].MaterialPerPart[index], Records[0].MaterialPercentToLTRPerPart[index]);
            result[3].push(Records[0].FreightAndDutyPerPart[index], Records[0].FreightAndDutyPercentToLTRPerPart[index]);
            result[4].push(Records[0].Manufacturing_PerPart[index], Records[0].Manufacturing_PercentToLTRPerPart[index]);
            result[5].push(Records[0].StUp_OpsExp_PerPart[index], Records[0].StUp_OpsExp_PercentToLTRPerPart[index]);
            result[6].push(Records[0].OtherIncremental_TlRebill_PerPart[index], Records[0].OtherIncremental_TlRebill_PercentToLTRPerPart[index]);
            result[7].push(Records[0].FactoryProfitPerPart[index], Records[0].FactoryProfitPercentToLTRPerPart[index]);
            result[8].push(Records[0].MfgDAndAPerPart[index], Records[0].MfgDAndAPercentToLTRPerPart[index]);
            result[9].push(Records[0].OCOGSPerPart[index], Records[0].OCOGSPercentToLTRPerPart[index]);
            result[10].push(Records[0].SGAndAPerPart[index], Records[0].SGAndAPercentToLTRPerPart[index]);
            result[11].push(Records[0].EngineeringPerPart[index], Records[0].EngineeringPercentToLTRPerPart[index]);
            result[12].push(Records[0].OperatingIncomePerPart[index], Records[0].OperatingIncomePercentToLTRPerPart[index]);
            result[13].push("", "");
            result[14].push("", "");
            result[15].push("", "");
            result[16].push("", "");
            result[17].push("", "");
            result[18].push(null, null)

        });

        return result;
    }

}

export class FinancialDashboardRowModel {
    CostStudy = "";
    Version = "";
    VolumeK = "";
    TotalRevenue = "";
    TotalRevenueYr1 = "";
    TotalRevenueM = "";
    OutsideProductSales = "";
    OperatingIncome = "";
    OperatingIncomePerecent = "";
    NPVk = "";
    IRR = "";
    Year1Price = "";
    Year1PriceHVP = "";
    CustomerFwL = "";
    MatlYear1 = "";
    MatlYear1HVP = "";
    MatlProgramAvg = "";
    MatlProgramAvgHVP = "";
    MatlPercent = "";
    ApplicationEngineeringK = "";
    CIAndPursuitEngineeringK = "";
    StudiedEngineeringK = "";
    RAndDTaxK = "";
    GrossEngK = "";
    EngineeringRebillRevenueK = "";
    ApplicationEngineeringPercentToLTR = "";
    CIAndPursuitEngineeringPercentToLTR = "";
    StudiedEngineeringPercentToLTR = "";
    RAndDTaxPercentToLTR = "";
    GrossEngPercentToLTR = "";
    EngineeringRebillRevenuePercentToLTR = "";
    FacilitiesK = "";
    ToolingK = "";
    ExpenseK = "";
    GrossInvestmentK = "";
    ToolingRebillK = "";
    NetInvestmentK = "";
    NetCapexK = "";
    FacilitiesPercentToLTR = "";
    ToolingPercentToLTR = "";
    ExpensePercentToLTR = "";
    GrossInvestmentPercentToLTR = "";
    ToolingRebillPercentToLTR = "";
    NetInvestmentPercentToLTR = "";
    NetCapexPercentToLTR = "";
    MERebillableToolingK = "";
    AllVendorToolsK = "";
    NetToolRebillK = "";
    RevenuePerUnit = "";
    MaterialPerUnit = "";
    FreightAndDutyPerUnit = "";
    Manufacturing_PerUnit = "";
    StUp_OpsExp_PerUnit = "";
    OtherIncremental_TlRebill_PerUnit = "";
    FactoryProfitPerUnit = "";
    MfgDAndAPerUnit = "";
    OCOGSPerUnit = "";
    SGAndAPerUnit = "";
    EngineeringPerUnit = "";
    OperatingIncomePerUnit = "";
    MaterialPercentToLTR = "";
    FreightAndDutyPercentToLTR = "";
    Manufacturing_PercentToLTR = "";
    StUp_OpsExp_PercentToLTR = "";
    OtherIncremental_TlRebill_PercentToLTR = "";
    FactoryProfitPercentToLTR = "";
    MfgDAndAPercentToLTR = "";
    OCOGSPercentToLTR = "";
    SGAndAPercentToLTR = "";
    EngineeringPercentToLTR = "";
    OperatingIncomePercentToLTR = "";
    RevenueYr1PerUnit = "";
    MaterialYr1PerUnit = "";
    FreightAndDutyYr1PerUnit = "";
    ManufacturingYr1_PerUnit = "";
    StUp_OpsExpYr1_PerUnit = "";
    OtherIncremental_TlRebillYr1_PerUnit = "";
    FactoryProfitYr1PerUnit = "";
    MfgDAndAYr1PerUnit = "";
    OCOGSYr1PerUnit = "";
    SGAndAYr1PerUnit = "";
    EngineeringYr1PerUnit = "";
    OperatingIncomeYr1PerUnit = "";
    MaterialYr1PercentToLTR = "";
    FreightAndDutyYr1PercentToLTR = "";
    ManufacturingYr1_PercentToLTR = "";
    StUp_OpsExpYr1_PercentToLTR = "";
    OtherIncremental_TlRebillYr1_PercentToLTR = "";
    FactoryProfitYr1PercentToLTR = "";
    MfgDAndAYr1PercentToLTR = "";
    OCOGSYr1PercentToLTR = "";
    SGAndAYr1PercentToLTR = "";
    EngineeringYr1PercentToLTR = "";
    OperatingIncomeYr1PercentToLTR = "";
    APRs = "";
    NCPs = "";
    MaterialAPRs = "";
    Parts = [];
    RevenuePerPart = [];
    MaterialPerPart = [];
    FreightAndDutyPerPart = [];
    Manufacturing_PerPart = [];
    StUp_OpsExp_PerPart = [];
    OtherIncremental_TlRebill_PerPart = [];
    FactoryProfitPerPart = [];
    MfgDAndAPerPart = [];
    OCOGSPerPart = [];
    SGAndAPerPart = [];
    EngineeringPerPart = [];
    OperatingIncomePerPart = [];
    MaterialPercentToLTRPerPart = [];
    FreightAndDutyPercentToLTRPerPart = [];
    Manufacturing_PercentToLTRPerPart = [];
    StUp_OpsExp_PercentToLTRPerPart = [];
    OtherIncremental_TlRebill_PercentToLTRPerPart = [];
    FactoryProfitPercentToLTRPerPart = [];
    MfgDAndAPercentToLTRPerPart = [];
    OCOGSPercentToLTRPerPart = [];
    SGAndAPercentToLTRPerPart = [];
    EngineeringPercentToLTRPerPart = [];
    OperatingIncomePercentToLTRPerPart = [];

    constructor(version, calculations, volumes, saleableParts) {

        let calculationHelper = new CalculationHelper();
        let volume = 0;
        let highestVolumePart = "";
        let highestVolume = 0;
        this.CostStudy = version.ECRNumber.Value.Fields[0];
        this.Version = version.Name;
        let volumeYr1 = 0;

        let partData = calculations

        let outsideProductSalesPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.OUTSIDE_PRODUCT_SALES }]);
        let outsideProductSales = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.OUTSIDE_PRODUCT_SALES }]);
        let year1 = Object.keys(outsideProductSalesPerYear)[calculationHelper.findFirstYearIndexHelper(outsideProductSalesPerYear)];

        this.APRs = calculationHelper.getAdjustment(version?.Adjustments, CalcualtionResultKeys.APRS, volumes)
        this.MaterialAPRs = calculationHelper.getAdjustment(version?.Adjustments, CalcualtionResultKeys.MATERIAL_APRS, volumes)
        this.NCPs = calculationHelper.getAdjustment(version?.Adjustments, CalcualtionResultKeys.NCPS, volumes)

        for (var vKey in volumes) {
            let partVolume = volumes[vKey].total
            volume += partVolume;
            if (volumes[vKey].firstYear == year1) {
                volumeYr1 += volumes[vKey].first;
            }

            if (partVolume > highestVolume) {
                highestVolume = partVolume;
                highestVolumePart = vKey;
            }

        }
        let hvpData = partData.filter(x => (x.partNumber + "|" + x.partRev + "|" + x.partSuffix) === highestVolumePart);
        let volumesHVP = Object.keys(volumes)
            .filter(key => key == highestVolumePart)
            .reduce((obj, key) => {
                obj[key] = volumes[key];
                return obj;
            }, {});

        this.VolumeK = volume / 1000;


        this.TotalRevenue = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.TOTAL_REVENUE }])
        let totalReveunePerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.TOTAL_REVENUE }])
        this.TotalRevenueYr1 = totalReveunePerYear[year1] ?? 0;

        this.OutsideProductSales = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.OUTSIDE_PRODUCT_SALES }]);
        this.OperatingIncome = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.OPERATING_INCOME, line: CalcualtionResultKeys.OPERATING_INCOME }]);
        let operatingIncomePerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.OPERATING_INCOME, line: CalcualtionResultKeys.OPERATING_INCOME }]);
        let operatingIncomeYr1 = calculationHelper.getNumber(operatingIncomePerYear[year1] ?? 0);

        let outsideProductSalesPerYearHVP = calculationHelper.perYearTotalCalculation(hvpData, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.OUTSIDE_PRODUCT_SALES }]);
        let outsideProductSalesHVP = calculationHelper.totalCalculation(hvpData, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.OUTSIDE_PRODUCT_SALES }]);
        let year1HVP = Object.keys(outsideProductSalesPerYearHVP)[calculationHelper.findFirstYearIndexHelper(outsideProductSalesPerYearHVP)];

        this.TotalRevenueM = this.TotalRevenue / 1000000;
        this.OperatingIncomePercent = this.OperatingIncome / this.TotalRevenue;

        this.NPVk = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.DISCOUNTED_CASH_FLOW, line: CalcualtionResultKeys.DISCOUNTED_CASH_FLOW }]) / 1000;

        //-- IRR
        let netCashFlow = {};
        let partNetCashFlow = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.NET_CASH_FLOW, line: CalcualtionResultKeys.NET_CASH_FLOW }]);
        for (var pNCF in partNetCashFlow) {
            netCashFlow[pNCF] = calculationHelper.getNumber(netCashFlow[pNCF] ?? 0) + calculationHelper.getNumber(partNetCashFlow[pNCF] ?? 0);
        }

        let arrNetCashFlow = [];
        for (var ncfKey in netCashFlow) {
            arrNetCashFlow.push(netCashFlow[ncfKey]);
        }
        this.IRR = calculationHelper.irr(arrNetCashFlow);
        //--

        //-- Year 1 Price
        let pricePerYear = calculationHelper.perYearPerPcCalculation(partData, volumes, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.OUTSIDE_PRODUCT_SALES }]);
        this.Year1Price = pricePerYear[year1];

        let pricePerYearHVP = calculationHelper.perYearPerPcCalculation(hvpData, volumesHVP, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.OUTSIDE_PRODUCT_SALES }]);
        this.Year1PriceHVP = pricePerYearHVP[year1HVP];
        //--

        this.CustomerFwL = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.TAXABLE_INCOME, line: CalcualtionResultKeys.FORWARD_LEVERAGE }])

        //-- Material Year 1
        if (calculationHelper.hasNewMaterialBucket(partData)) {
            let materialPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MATERIAL }]);
            this.MatlYear1 = materialPerYear[year1] / outsideProductSalesPerYear[year1];

            let materialPerYearHVP = calculationHelper.perYearTotalCalculation(hvpData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MATERIAL }]);
            this.MatlYear1HVP = materialPerYearHVP[year1HVP] / outsideProductSalesPerYearHVP[year1HVP];

        } else {
            let inboundFreightPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.INBOUND_FREIGHT }]);
            let inboundDutyPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.INBOUND_DUTY }]);
            let materialFreightDutyPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MATERIAL_AND_FREIGHT_DUTY }]);

            let freightYear1 = inboundFreightPerYear[year1] ?? 0;
            let dutyYear1 = inboundDutyPerYear[year1] ?? 0;
            let materialFreightDutyYear1 = materialFreightDutyPerYear[year1] ?? 0
            this.MatlYear1 = (materialFreightDutyYear1 - (freightYear1 + dutyYear1)) / outsideProductSalesPerYear[year1];

            let inboundFreightPerYearHVP = calculationHelper.perYearTotalCalculation(hvpData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.INBOUND_FREIGHT }]);
            let inboundDutyPerYearHVP = calculationHelper.perYearTotalCalculation(hvpData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.INBOUND_DUTY }]);
            let materialFreightDutyPerYearHVP = calculationHelper.perYearTotalCalculation(hvpData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MATERIAL_AND_FREIGHT_DUTY }]);

            let freightYear1HVP = inboundFreightPerYearHVP[year1HVP] ?? 0;
            let dutyYear1HVP = inboundDutyPerYearHVP[year1HVP] ?? 0;
            let materialFreightDutyYear1HVP = materialFreightDutyPerYearHVP[year1HVP] ?? 0
            this.MatlYear1HVP = (materialFreightDutyYear1HVP - (freightYear1HVP + dutyYear1HVP)) / outsideProductSalesPerYearHVP[year1HVP];
        }
        //--

        //-- Material Prgm Avg
        let inboundFreight = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.INBOUND_FREIGHT }]);
        let inboundDuty = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.INBOUND_DUTY }]);
        let freightAndDuty = inboundFreight + inboundDuty;

        let inboundFreightPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.INBOUND_FREIGHT }]);
        let inboundDutyPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.INBOUND_DUTY }]);
        let freightAndDutyYr1 = calculationHelper.getNumber(inboundFreightPerYear[year1] ?? 0) + calculationHelper.getNumber(inboundDutyPerYear[year1] ?? 0);

        let material = 0;
        let materialYr1 = 0;

        if (calculationHelper.hasNewMaterialBucket(partData)) {

            material = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MATERIAL }]);
            let materialHVP = calculationHelper.totalCalculation(hvpData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MATERIAL }]);
            let materialPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MATERIAL }]);
            materialYr1 = materialPerYear[year1] ?? 0;

            this.MatlProgramAvg = material / outsideProductSales;
            this.MatlProgramAvgHVP = materialHVP / outsideProductSalesHVP;
        }
        else {
            material = (calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MATERIAL_AND_FREIGHT_DUTY }]) - freightAndDuty);
            let materialPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MATERIAL_AND_FREIGHT_DUTY }]);
            materialYr1 = calculationHelper.getNumber(materialPerYear[year1] ?? 0) - calculationHelper.getNumber(freightAndDutyYr1 ?? 0);

            this.MatlProgramAvg = material / outsideProductSales;

            let inboundFreightHVP = calculationHelper.totalCalculation(hvpData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.INBOUND_FREIGHT }]);
            let inboundDutyHVP = calculationHelper.totalCalculation(hvpData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.INBOUND_DUTY }]);
            let freightAndDutyHVP = inboundFreightHVP + inboundDutyHVP;
            let materialHVP = (calculationHelper.totalCalculation(hvpData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MATERIAL_AND_FREIGHT_DUTY }]) - freightAndDutyHVP);
            this.MatlProgramAvgHVP = materialHVP / outsideProductSalesHVP;
        }
       //--

        //-- Material Percent
           this.MatlPercent = material / this.TotalRevenue;
       //--

        let applicationEngineering = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.COST_OF_SALES_DEPRECIATION_AND_AMORTIZATION, line: CalcualtionResultKeys.APPLICATION_ENGINEERING_AMORTIZATION }]);
        let applicationEngineeringPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.COST_OF_SALES_DEPRECIATION_AND_AMORTIZATION, line: CalcualtionResultKeys.APPLICATION_ENGINEERING_AMORTIZATION }]);
        let applicationEngineeringYr1 = calculationHelper.getNumber(applicationEngineeringPerYear[year1] ?? 0);

        this.ApplicationEngineeringK = applicationEngineering / 1000;
        this.ApplicationEngineeringPercentToLTR = applicationEngineering / this.TotalRevenue;

        let ciAndPursuitEngineering = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.OTHER_OPERATING_EXPENSES, line: CalcualtionResultKeys.PURSUIT_AND_CI_ENGINEERING }]);
        let ciAndPursuitEngineeringPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.OTHER_OPERATING_EXPENSES, line: CalcualtionResultKeys.PURSUIT_AND_CI_ENGINEERING }]);
        let ciAndPursuitEngineeringYr1 = calculationHelper.getNumber(ciAndPursuitEngineeringPerYear[year1] ?? 0);

        this.CIAndPursuitEngineeringK = ciAndPursuitEngineering / 1000;
        this.CIAndPursuitEngineeringPercentToLTR = ciAndPursuitEngineering / this.TotalRevenue;

        //-- Studied Engineering, Gross, R & D Tax
        let grossEngingeering = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.TAXABLE_INCOME, line: CalcualtionResultKeys.ENGINEERING }]) * -1;
        this.GrossEngK = grossEngingeering / 1000;
        this.GrossEngPercentToLTR = grossEngingeering / this.TotalRevenue;

        let researchEngineering = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.OTHER_OPERATING_EXPENSES, line: CalcualtionResultKeys.RESEARCH_ENGINEERING }])
        let researchEngineeringPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.OTHER_OPERATING_EXPENSES, line: CalcualtionResultKeys.RESEARCH_ENGINEERING }]);
        let researchEngineeringYr1 = calculationHelper.getNumber(researchEngineeringPerYear[year1] ?? 0);

        let studiedEngineering = grossEngingeering - researchEngineering;
        this.StudiedEngineeringK = studiedEngineering / 1000;
        this.StudiedEngineeringPercentToLTR = studiedEngineering / this.TotalRevenue;
        this.RAndDTaxK = researchEngineering / 1000;
        this.RAndDTaxPercentToLTR = researchEngineering / this.TotalRevenue;
        //--

        let engineeringRebillRevenue = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.ENGINEERING_REBILL }]);
        this.EngineeringRebillRevenueK = engineeringRebillRevenue / 1000;
        this.EngineeringRebillRevenuePercentToLTR = engineeringRebillRevenue / this.TotalRevenue;

        let facilities = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.CAPITAL_INVESTMENTS, line: CalcualtionResultKeys.CAPITAL_INVESTMENTS }]);
        this.FacilitiesK = facilities / 1000;
        this.FacilitiesPercentToLTR = facilities / this.TotalRevenue;

        let tooling = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.TOOLING_INVESTMENTS, line: CalcualtionResultKeys.TOOLING_INVESTMENTS }]);
        this.ToolingK = tooling / 1000;
        this.ToolingPercentToLTR = tooling / this.TotalRevenue;

        let expense = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.EXPENSE_INVESTMENTS, line: CalcualtionResultKeys.EXPENSE_INVESTMENTS }]);
        this.ExpenseK = expense / 1000;
        this.ExpensePercentToLTR = expense / this.TotalRevenue;

        let grossInvest = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.GROSS_INVEST, line: CalcualtionResultKeys.GROSS_INVEST }]);
        this.GrossInvestmentK = grossInvest / 1000;
        this.GrossInvestmentPercentToLTR = grossInvest / this.TotalRevenue;

        let toolingRebill = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.TOOLING_REBILL, line: CalcualtionResultKeys.TOOLING_REBILL }]);
        this.ToolingRebillK = toolingRebill / 1000;
        this.ToolingRebillPercentToLTR = toolingRebill / this.TotalRevenue;

        let netInvest = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.NET_INVEST, line: CalcualtionResultKeys.NET_INVEST }]);
        this.NetInvestmentK = netInvest / 1000;
        this.NetInvestmentPercentToLTR = netInvest / this.TotalRevenue;

        let netCapex = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.NET_CAPEX, line: CalcualtionResultKeys.NET_CAPEX }]);
        this.NetCapexK = netCapex / 1000;
        this.NetCapexPercentToLTR = netCapex / this.TotalRevenue;

        let meRebillableTooling = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.TOOLING_INVESTMENTS, line: CalcualtionResultKeys.MANUFACTURING_TOOLING_REBILL_ELIGIBLE }]);
        this.MERebillableToolingK = meRebillableTooling / 1000;

        let vendorRebillableTooling = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.TOOLING_INVESTMENTS, line: CalcualtionResultKeys.VENDOR_TOOLING_REBILL_ELIGIBLE }]);
        let vendorToolingNonRebill = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.TOOLING_INVESTMENTS, line: CalcualtionResultKeys.VENDOR_TOOLING_NON_REBILL }]);
        let allVendorTools = vendorRebillableTooling + vendorToolingNonRebill;

        this.AllVendorToolsK = allVendorTools / 1000;

        let netToolRebill = toolingRebill - (meRebillableTooling + allVendorTools) ;
        this.NetToolRebillK = netToolRebill / 1000;

        this.RevenuePerUnit = this.TotalRevenue / volume;
        this.RevenueYr1PerUnit = this.TotalRevenueYr1 / volumeYr1;
        this.MaterialPerUnit = material / volume;
        this.MaterialYr1PerUnit = materialYr1 / volumeYr1;
        this.MaterialPercentToLTR = material / this.TotalRevenue;
        this.MaterialYr1PercentToLTR = materialYr1 / this.TotalRevenueYr1;
        this.FreightAndDutyPerUnit = freightAndDuty / volume;
        this.FreightAndDutyYr1PerUnit = freightAndDutyYr1 / volumeYr1;
        this.FreightAndDutyPercentToLTR = freightAndDuty / this.TotalRevenue;
        this.FreightAndDutyYr1PercentToLTR = freightAndDutyYr1 / this.TotalRevenueYr1;

        //-- Manufacturing + St up + Ops Exp
        let startupLaunchCost = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.STARTUP_LAUNCH_COST }]);
        let operationsExpense = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.OPERATIONS_EXPENSE }]);
        let startupLaunchCostPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.STARTUP_LAUNCH_COST }]);
        let operationsExpensePerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.OPERATIONS_EXPENSE }]);

        var manufacturing;
        var manufacturingYr1;
        var stUp_OpsExp;
        var stUp_OpsExpYr1;
        if (calculationHelper.hasNewMaterialBucket(partData)) {
            let mfg = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MANUFACTURING }]);
            let mfgPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MANUFACTURING }]);
            stUp_OpsExp = (startupLaunchCost + operationsExpense)
            stUp_OpsExpYr1 = (calculationHelper.getNumber(startupLaunchCostPerYear[year1] ?? 0) + calculationHelper.getNumber(operationsExpensePerYear[year1] ?? 0));
            manufacturing = mfg - stUp_OpsExp;
            manufacturingYr1 = calculationHelper.getNumber(mfgPerYear[year1] ?? 0) - stUp_OpsExpYr1;
        } else {
            let directLabor = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.DIRECT_LABOR }]);
            let miscellaneousMfgPieceCost = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MISCELLANEOUS_MANUFACTURING_PIECE_COST }]);
            let totalBurdenWithoutDirectLabor = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.TOTAL_BURDEN_WO_DIRECT_LABOR }]);
            let expendablePackagingForSaleablePart = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.EXPENDABLE_PACKAGING_FOR_SALEABLE_PRODUCT }]);
            let directLaborPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.DIRECT_LABOR }]);
            let miscellaneousMfgPieceCostPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MISCELLANEOUS_MANUFACTURING_PIECE_COST }]);
            let totalBurdenWithoutDirectLaborPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.TOTAL_BURDEN_WO_DIRECT_LABOR }]);
            let expendablePackagingForSaleablePartPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.EXPENDABLE_PACKAGING_FOR_SALEABLE_PRODUCT }]);
            manufacturing = directLabor + miscellaneousMfgPieceCost + totalBurdenWithoutDirectLabor + expendablePackagingForSaleablePart;
            manufacturingYr1 = calculationHelper.getNumber(directLaborPerYear[year1] ?? 0) + calculationHelper.getNumber(miscellaneousMfgPieceCostPerYear[year1] ?? 0) + calculationHelper.getNumber(totalBurdenWithoutDirectLaborPerYear[year1] ?? 0) + calculationHelper.getNumber(expendablePackagingForSaleablePartPerYear[year1] ?? 0);
            stUp_OpsExp = startupLaunchCost + operationsExpense;
            stUp_OpsExpYr1 = calculationHelper.getNumber(startupLaunchCostPerYear[year1] ?? 0) + calculationHelper.getNumber(operationsExpensePerYear[year1] ?? 0);
        }
        this.Manufacturing_PerUnit = manufacturing / volume;
        this.ManufacturingYr1_PerUnit = manufacturingYr1 / volumeYr1;
        this.StUp_OpsExp_PerUnit = stUp_OpsExp / volume;
        this.StUp_OpsExpYr1_PerUnit = stUp_OpsExpYr1 / volumeYr1;
        this.Manufacturing_PercentToLTR = manufacturing / this.TotalRevenue;
        this.ManufacturingYr1_PercentToLTR = manufacturingYr1 / this.TotalRevenueYr1;
        this.StUp_OpsExp_PercentToLTR = stUp_OpsExp / this.TotalRevenue;
        this.StUp_OpsExpYr1_PercentToLTR = stUp_OpsExpYr1 / this.TotalRevenueYr1;
        //--

        //--Other Incremental + TL Rebill
        let otherIncrementalCost = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.OTHER_INCREMENTAL_COST }]);
        let toolRebillExpense = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.TOOLING_REBILL_EXPENSE }]);
        let otherIncrementalCostPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.OTHER_INCREMENTAL_COST }]);
        let toolRebillExpensePerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.TOOLING_REBILL_EXPENSE }]);
        let otherIncremental_tlRebill = otherIncrementalCost + toolRebillExpense;
        let otherIncremental_tlRebillYr1 = calculationHelper.getNumber(otherIncrementalCostPerYear[year1] ?? 0) + calculationHelper.getNumber(toolRebillExpensePerYear[year1] ?? 0);
        this.OtherIncremental_TlRebill_PerUnit = otherIncremental_tlRebill / volume;
        this.OtherIncremental_TlRebillYr1_PerUnit = otherIncremental_tlRebillYr1 / volumeYr1;
        this.OtherIncremental_TlRebill_PercentToLTR = otherIncremental_tlRebill / this.TotalRevenue;
        this.OtherIncremental_TlRebillYr1_PercentToLTR = otherIncremental_tlRebillYr1 / this.TotalRevenueYr1;
        //--

        let factoryProfit = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_PROFIT, line: CalcualtionResultKeys.FACTORY_PROFIT }]);
        let factoryProfitPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_PROFIT, line: CalcualtionResultKeys.FACTORY_PROFIT }]);
        this.FactoryProfitPerUnit = factoryProfit / volume;
        this.FactoryProfitYr1PerUnit = calculationHelper.getNumber(factoryProfitPerYear[year1] ?? 0) / volumeYr1;
        this.FactoryProfitPercentToLTR = factoryProfit / this.TotalRevenue;
        this.FactoryProfitYr1PercentToLTR = calculationHelper.getNumber(factoryProfitPerYear[year1] ?? 0) / this.TotalRevenueYr1;

        //Mfg D & A
        let manufactutingDepreciationCurrent = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.COST_OF_SALES_DEPRECIATION_AND_AMORTIZATION, line: CalcualtionResultKeys.MANUFACTURING_DEPRECIATION_CURRENT }]);
        let newManufacturingDepreciation = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.COST_OF_SALES_DEPRECIATION_AND_AMORTIZATION, line: CalcualtionResultKeys.NEW_MANUFACTURING_DEPRECIATION }]);
        let specialToolingAmortization = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.COST_OF_SALES_DEPRECIATION_AND_AMORTIZATION, line: CalcualtionResultKeys.SPECIAL_TOOLING_AMORTIZATION }]);
        let manufactutingDepreciationCurrentPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.COST_OF_SALES_DEPRECIATION_AND_AMORTIZATION, line: CalcualtionResultKeys.MANUFACTURING_DEPRECIATION_CURRENT }]);
        let newManufacturingDepreciationPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.COST_OF_SALES_DEPRECIATION_AND_AMORTIZATION, line: CalcualtionResultKeys.NEW_MANUFACTURING_DEPRECIATION }]);
        let specialToolingAmortizationPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.COST_OF_SALES_DEPRECIATION_AND_AMORTIZATION, line: CalcualtionResultKeys.SPECIAL_TOOLING_AMORTIZATION }]);
        let mfgDAndA = manufactutingDepreciationCurrent + newManufacturingDepreciation + specialToolingAmortization;
        let mfgDAndAYr1 = calculationHelper.getNumber(manufactutingDepreciationCurrentPerYear[year1] ?? 0) + calculationHelper.getNumber(newManufacturingDepreciationPerYear[year1] ?? 0) + calculationHelper.getNumber(specialToolingAmortizationPerYear[year1] ?? 0);
        this.MfgDAndAPerUnit = mfgDAndA / volume;
        this.MfgDAndAYr1PerUnit = mfgDAndAYr1 / volumeYr1;
        this.MfgDAndAPercentToLTR = mfgDAndA / this.TotalRevenue;
        this.MfgDAndAYr1PercentToLTR = mfgDAndAYr1 / this.TotalRevenueYr1;
        //--

        let ocogs = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.OTHER_COGS, line: CalcualtionResultKeys.OTHER_COGS }]);
        let ocogsPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.OTHER_COGS, line: CalcualtionResultKeys.OTHER_COGS }]);
        let ocogsYr1 = calculationHelper.getNumber(ocogsPerYear[year1] ?? 0);
        this.OCOGSPerUnit = ocogs / volume;
        this.OCOGSYr1PerUnit = ocogsYr1 / volumeYr1;
        this.OCOGSPercentToLTR = ocogs / this.TotalRevenue;
        this.OCOGSYr1PercentToLTR = ocogsYr1 / this.TotalRevenueYr1;

        let sgAndA = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.SG_AND_A, line: CalcualtionResultKeys.SG_AND_A }]);
        let sgAndAPerYear = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.SG_AND_A, line: CalcualtionResultKeys.SG_AND_A }]);
        let sgAndAYr1 = calculationHelper.getNumber(sgAndAPerYear[year1] ?? 0);
        this.SGAndAPerUnit = sgAndA / volume;   
        this.SGAndAYr1PerUnit = sgAndAYr1 / volumeYr1; 
        this.SGAndAPercentToLTR = sgAndA / this.TotalRevenue;
        this.SGAndAYr1PercentToLTR = sgAndAYr1 / this.TotalRevenueYr1;

        let engineering = calculationHelper.getNumber(applicationEngineering ?? 0) + calculationHelper.getNumber(researchEngineering ?? 0) + calculationHelper.getNumber(ciAndPursuitEngineering ?? 0);
        let engineeringYr1 = calculationHelper.getNumber(applicationEngineeringYr1 ?? 0) + calculationHelper.getNumber(researchEngineeringYr1 ?? 0) + calculationHelper.getNumber(ciAndPursuitEngineeringYr1 ?? 0);


        this.EngineeringPerUnit = engineering / volume;
        this.EngineeringYr1PerUnit = engineeringYr1 / volumeYr1;
        this.EngineeringPercentToLTR = engineering / this.TotalRevenue;
        this.EngineeringYr1PercentToLTR = engineeringYr1 / this.TotalRevenueYr1;

        this.OperatingIncomePerUnit = this.OperatingIncome / volume;
        this.OperatingIncomeYr1PerUnit = operatingIncomeYr1 / volumeYr1;
        this.OperatingIncomePercentToLTR = this.OperatingIncome / this.TotalRevenue
        this.OperatingIncomeYr1PercentToLTR = operatingIncomeYr1 / this.TotalRevenueYr1;

        saleableParts?.forEach(saleablePart => {
            let SaleablePartNumber = saleablePart.Part?.Number?.Fields[0] ?? "";
            let SaleablePartRev = saleablePart.Part?.DrawingRevision?.Fields[0]?.Fields[0] ?? "";
            let SaleablePartSuffix = saleablePart.Part?.Suffix?.Fields[0]?.Fields[0] ?? "";
            let OptionName = saleablePart.OptionName

            let partCalculations = calculations.filter(item => { return item.partNumber === SaleablePartNumber && item.partRev === SaleablePartRev && item.partSuffix === SaleablePartSuffix && item.groupName === OptionName })
            let partVolumes = 
            Object.keys(volumes)
                .filter(key => key === calculationHelper.getPartKey(saleablePart))
                .reduce((obj, key) => {
                    obj[key] = volumes[key];
                    return obj;
                }, {});

            let partData = new FinancialDashboardRowModel(version, partCalculations, partVolumes);
            
            this.RevenuePerPart.push(partData.RevenuePerUnit);
            this.MaterialPerPart.push(partData.MaterialPerUnit);
            this.MaterialPercentToLTRPerPart.push(partData.MaterialPercentToLTR);
          
            this.Parts.push(SaleablePartNumber + (SaleablePartRev ? " Rev." + SaleablePartRev : "") + SaleablePartSuffix + " " + OptionName);
            this.RevenuePerPart.push(partData.RevenuePerUnit);
            this.MaterialPerPart.push(partData.MaterialPerUnit);
            this.FreightAndDutyPerPart.push(partData.FreightAndDutyPerUnit);
            this.Manufacturing_PerPart.push(partData.Manufacturing_PerUnit);
            this.StUp_OpsExp_PerPart.push(partData.StUp_OpsExp_PerUnit);
            this.OtherIncremental_TlRebill_PerPart.push(partData.OtherIncremental_TlRebill_PerUnit);
            this.FactoryProfitPerPart.push(partData.FactoryProfitPerUnit);
            this.MfgDAndAPerPart.push(partData.MfgDAndAPerUnit);
            this.OCOGSPerPart.push(partData.OCOGSPerUnit);
            this.SGAndAPerPart.push(partData.SGAndAPerUnit);
            this.EngineeringPerPart.push(partData.EngineeringPerUnit);
            this.OperatingIncomePerPart.push(partData.OperatingIncomePerUnit);
            this.MaterialPercentToLTRPerPart.push(partData.MaterialPercentToLTR);
            this.FreightAndDutyPercentToLTRPerPart.push(partData.FreightAndDutyPercentToLTR);
            this.Manufacturing_PercentToLTRPerPart.push(partData.Manufacturing_PercentToLTR);
            this.StUp_OpsExp_PercentToLTRPerPart.push(partData.StUp_OpsExp_PercentToLTR);
            this.OtherIncremental_TlRebill_PercentToLTRPerPart.push(partData.OtherIncremental_TlRebill_PercentToLTR);
            this.FactoryProfitPercentToLTRPerPart.push(partData.FactoryProfitPercentToLTR);
            this.MfgDAndAPercentToLTRPerPart.push(partData.MfgDAndAPercentToLTR);
            this.OCOGSPercentToLTRPerPart.push(partData.OCOGSPercentToLTR);
            this.SGAndAPercentToLTRPerPart.push(partData.SGAndAPercentToLTR);
            this.EngineeringPercentToLTRPerPart.push(partData.EngineeringPercentToLTR);
            this.OperatingIncomePercentToLTRPerPart.push(partData.OperatingIncomePercentToLTR);
        });
    }

}